import * as React from 'react';

import { block } from './utils';

export interface BillingCycleOptionLabelProps {
  cost: React.ReactNode;
  children: React.ReactNode;
}

const BillingCycleOptionLabel: React.SFC<BillingCycleOptionLabelProps> = ({
  cost,
  children,
}) => {
  return (
    <div className={block('label')}>
      <div className={block('description')}>{children}</div>

      <div className={block('cost')}>{cost}</div>
    </div>
  );
};

export default BillingCycleOptionLabel;
